module.exports = __webpack_public_path__ + "static/expansion-89a6825fd60bd2320728d8736ed10c30.png";